export const replaceSymbol = (value) =>
	value.replace(/[-*&%#\/$!@%^&*|"' {}\]\[=?<>\\;:+~`()]/g, '')

const regex = RegExp(/[-*&%#\/$!@%^&*|"' {}\]\[=?<>\\;:+~`()]/g)

export const isIncorrectSymbol = (value) => regex.test(value)
